import "../PublicWebsite.css";
import { useTranslation } from "react-i18next";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import DatasetOutlinedIcon from "@mui/icons-material/DatasetOutlined";
import SchemaOutlinedIcon from "@mui/icons-material/SchemaOutlined";

const DEFAULT_FIGURES = [
  {
    key: "participants",
    value: 2478,
    labelKey: "landing.recurrent",
    label: "Participants",
    detailKey: "landing.percentage_org",
    detail: "Organizations connected to the data space",
    icon: GroupsOutlinedIcon,
    tone: "blue",
  },
  {
    key: "datasets",
    value: 219820,
    labelKey: "landing.dataset_pub",
    label: "Published datasets",
    detailKey: "landing.num_datasets",
    detail: "Datasets available in the catalogue",
    icon: DatasetOutlinedIcon,
    tone: "green",
  },
  {
    key: "datamodels",
    value: 213,
    labelKey: "landing.dataModel_publish",
    label: "Published data models",
    detailKey: "landing.percentage_contracts",
    detail: "Reusable vocabularies and semantic models",
    icon: SchemaOutlinedIcon,
    tone: "amber",
  },
];

const formatFigure = (value) =>
  typeof value === "number"
    ? new Intl.NumberFormat("es-ES").format(value)
    : value;

export default function KeyFigures({ figures = DEFAULT_FIGURES }) {
  const { t } = useTranslation();
  return (
    <section className="kf-wrapper">
      <div className="kf-box">
        {figures.map((figure) => {
          const fallback = DEFAULT_FIGURES.find(
            (item) => item.key === figure.key,
          );
          const Icon = figure.icon || fallback?.icon || DatasetOutlinedIcon;
          const tone = figure.tone || fallback?.tone || "blue";

          return (
            <article className={`kf-card kf-card-${tone}`} key={figure.key}>
              <div className="kf-card-top">
                <span className="kf-icon" aria-hidden="true">
                  <Icon fontSize="small" />
                </span>
              </div>
              <div className="kf-number">{formatFigure(figure.value)}</div>
              <p className="kf-text">
                {t(figure.labelKey, { defaultValue: figure.label })}
              </p>
              <p className="kf-detail">
                {figure.detailKey
                  ? t(figure.detailKey, {
                      defaultValue: figure.detail || fallback?.detail,
                    })
                  : figure.detail || fallback?.detail}
              </p>
            </article>
          );
        })}
      </div>
    </section>
  );
}
